import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ApiService } from 'src/app/core/services/api.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { Investment, CURRENCY_SYMBOLS, CURRENCY_OPTIONS, InvestmentCurrency } from 'src/app/core/endpoints/models/investments';
import { Router } from '@angular/router';
import * as moment from "moment";

@Component({
  selector: 'app-investments',
  templateUrl: './investments.component.html',
  styleUrls: ['./investments.component.scss']
})
export class InvestmentsComponent implements OnInit {
  @ViewChild('dt1') table: Table;
  @ViewChild('filter') filter: ElementRef;

  imageChangedEvent: Event | null = null;
  croppedActive: boolean = false;

  investments: Investment[] = [];
  usersOptions: any[] = [];
  loading: boolean = false;
  dialogInvestment: boolean = false;
  mode: 'edit' | 'register' = 'edit';
  stringPhoto: string = null;
  investmentSelected: Investment;

  currencyOptions = CURRENCY_OPTIONS;
  currencySymbols = CURRENCY_SYMBOLS;

  userSearch: any = null;
  startDateSearch: any = null;
  endDateSearch: any = null;

  form: FormGroup = this.fb.group({
    user_id: ['', Validators.required],
    reference: ['', Validators.required],
    name: ['', Validators.required],
    interest: ['', [Validators.required]],
    amount: ['', [Validators.required]],
    currency: ['EUR', [Validators.required]],
    start_date: [null],
    end_date: [null],
    description: [''],
    image: ['']
  });

  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private toast: ToastService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadUsers();
    this.loadInvestments();
  }

  loadInvestments(type=null) {
    var typeAction = type ? type : '';
    this.loading = true;
    this.apiService.getEntity(`investments?type=${typeAction}`).subscribe({
      next: (result) => {
        const today = moment().format('YYYY-MM-DD');
        this.investments = result.investments.map(inv => {
          let status = inv.status;
          if (status == 1 && inv.end_date && moment(inv.end_date, 'YYYY-MM-DD').isBefore(today)) {
            status = 3;
          }
          return {
            ...inv,
            status,
            name_email: inv.user ? inv.user.name + ' - ' + inv.user.email : '',
            name_identification: inv.user ? inv.user.name + ' - ' + inv.user.identification : '',
          };
        });
        console.log("🚀 ~ InvestmentsComponent ~ loadInvestments ~ this.investments:", this.investments)
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  loadUsers() {
    this.apiService.getEntity('users',2).subscribe({
      next: (result) => {
        this.usersOptions = result.users.map(user => ({
          ...user,
          name_email: user.name + ' - ' + user.email,
          name_identification: user ? user.name + ' - ' + user.identification : ''
        }));
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  clear(table: Table) {
    this.filter.nativeElement.value = '';
    table.clear();
    this.loadInvestments();
  }

  registerInvestment() {
    const formValue = this.form.value;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return this.toast.show('Aviso', 'Revise los datos del formulario', 'warn');
    }
    this.loading = true;
    this.form.patchValue({ image: this.stringPhoto });
	
    var startDate:any;
    if (typeof formValue.start_date === 'object') {
		startDate = moment(formValue.start_date).format('YYYY-MM-DD');
    } else {
		startDate = moment(formValue.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
	
    var endDate:any;
    if (typeof formValue.end_date === 'object') {
		endDate = moment(formValue.end_date).format('YYYY-MM-DD');
    } else {
		endDate = moment(formValue.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    
    if (moment(endDate).isSameOrBefore(startDate)) {
      this.loading = false;
      return this.toast.show('Aviso', 'La fecha fin es menor o igual a la fecha de inicio.', 'warn');
    } 

    this.form.patchValue({ start_date: startDate });
    this.form.patchValue({ end_date: endDate });
    

    this.apiService.addEntity('registerInvestment', this.form.value).subscribe({
      next: (result) => {
        this.dialogInvestment = false;
        this.toast.show('Inversión creada correctamente');
        this.loadInvestments();
        this.croppedActive = false;
        this.resetForm();
      },
      error: (err) => {
        let message = 'Ocurrió un error al crear la inversión, inténtelo de nuevo';
        if (err && err.error && err.error.errors) {
          message = '';
          const errors = err.error.errors;
          for (const field in errors) {
            errors[field].forEach(errorMessage => {
              message += `${errorMessage}\n`;
            });
          }
        }
        this.loading = false;
        this.toast.show('Error', message, 'error');
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  updateInvestment() {
    const formValue = this.form.value;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return this.toast.show('Aviso', 'Revise el formulario', 'warn');
    }
    this.loading = true;
    this.form.patchValue({ image: this.stringPhoto });
	
    var startDate:any;
    if (typeof formValue.start_date === 'object') {
		startDate = moment(formValue.start_date).format('YYYY-MM-DD');
    } else {
		startDate = moment(formValue.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
	
    var endDate:any;
    if (typeof formValue.end_date === 'object') {
		endDate = moment(formValue.end_date).format('YYYY-MM-DD');
    } else {
		endDate = moment(formValue.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    
    if (moment(endDate).isSameOrBefore(startDate)) {
      this.loading = false;
      return this.toast.show('Aviso', 'La fecha fin es menor o igual a la fecha de inicio.', 'warn');
    } 

    this.form.patchValue({ start_date: startDate });
    this.form.patchValue({ end_date: endDate });

    this.apiService.updateEntity('updateInvestment', this.investmentSelected.id, this.form.value).subscribe({
      next: (result) => {
        this.toast.show('Inversión actualizada correctamente');
        this.dialogInvestment = false;
        this.loadInvestments();
        this.croppedActive = false;
        this.resetForm();
      },
      error: (err) => {
        let message = 'Ocurrió un error al editar la inversión, inténtelo de nuevo';
        if (err && err.error && err.error.errors) {
          message = '';
          const errors = err.error.errors;
          for (const field in errors) {
            errors[field].forEach(errorMessage => {
              message += `${errorMessage}\n`;
            });
          }
        }
        this.loading = false;
        this.toast.show('Error', message, 'error');
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  deleteInvestment(investment: Investment) {
    if (this.loading) return;
    this.confirmationService.confirm({
      message: '¿Está seguro que desea eliminar la inversión?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loading = true;
        this.apiService.deleteEntity('deleteInvestment', investment.id).subscribe({
          next: () => {
            this.toast.show('Inversión eliminada correctamente');
            this.loadInvestments();
          },
          error: () => {
            this.toast.show('Error', 'Ocurrió un error eliminando la inversión, inténtelo de nuevo', 'error');
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  transactions(investment?: Investment) {
    localStorage.setItem('investment',investment.uuid);
    setTimeout(() => {
      if (investment) {
        this.router.navigate(['app/transactions']);
      }
    }, 250);
  }
  
  graphics(investment?: Investment) {
    localStorage.setItem('investment',investment.uuid);
    setTimeout(() => {
      if (investment) {
        this.router.navigate(['app/graphics']);
      }
    }, 250);
  }

  showDialog(investment?: Investment) {
    this.investmentSelected = undefined;
    this.stringPhoto = null;
    if (investment) {
      this.investmentSelected = investment;
      this.form.patchValue({
        user_id: investment.user_id,
        reference: investment.reference,
        name: investment.name,
        interest: investment.interest,
        amount: investment.amount,
        currency: investment.currency || 'EUR',
        start_date: moment(investment.start_date+' 12:00:00').format('DD-MM-YYYY'),
        end_date: moment(investment.end_date+' 12:00:00').format('DD-MM-YYYY'),
        description: investment.description,
        image: investment.image
      });
      if (investment.image) {
        this.stringPhoto = investment.image;
      }
    }
    this.mode = investment ? 'edit' : 'register';
    this.dialogInvestment = true;
  }

  deleteImage() {
    this.stringPhoto = null;
    this.croppedActive = false;
  }

  resetForm() {
    this.form.reset();
    this.stringPhoto = null;
  }

  handleUpload(event: any) {
    this.imageChangedEvent = event;
    this.croppedActive = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.stringPhoto = event.base64;
  }
  imageLoaded(image: LoadedImage) {}
  cropperReady() {}
  loadImageFailed() {}

  formatNumber(num: number): string {
    const fixedNum = num.toFixed(2);
    const [integerPart, decimalPart] = fixedNum.split('.');
    const withThousands = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if(parseFloat(decimalPart) === 0){
      return withThousands;
    }
    return `${withThousands},${decimalPart}`;
  }

  getCurrencySymbol(currency?: InvestmentCurrency): string {
    return CURRENCY_SYMBOLS[currency] || CURRENCY_SYMBOLS['EUR'];
  }

  search(){
    let userSearch = this.userSearch ? this.userSearch : '';
    let startDateSearch = this.startDateSearch ? this.startDateSearch : '';
    let endDateSearch = this.endDateSearch ? this.endDateSearch : '';
    
    var startDate:any = '';
    if (startDateSearch){
      if (typeof startDateSearch === 'object') {
        startDate = moment(startDateSearch).format('YYYY-MM-DD');
      } else {
        startDate = moment(startDateSearch, 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
    }
  
    var endDate:any = '';
    if (endDateSearch){
      if (typeof endDateSearch === 'object') {
        endDate = moment(endDateSearch).format('YYYY-MM-DD');
      } else {
        endDate = moment(endDateSearch, 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
    }
    

    if (startDateSearch && endDateSearch){
      if (moment(endDate).isSameOrBefore(startDate)) {
        this.loading = false;
        return this.toast.show('Aviso', 'La fecha fin es menor o igual a la fecha de inicio.', 'warn');
      } 
    }
    
    this.apiService.getEntity('investments?userSearch='+userSearch+'&startDate='+startDate+'&endDate='+endDate).subscribe({
      next: (result) => {
        this.investments = result.investments.map(inv => ({
          ...inv,
          name_email: inv.user ? inv.user.name + ' - ' + inv.user.email : '',
          name_identification: inv.user ? inv.user.name + ' - ' + inv.user.identification : '',
        }));
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
